import { CaseStudySequence, SimulationEhrSequence } from 'models/ui';
import { MultiLine } from 'components/common';

export interface CaseStudyOverviewViewProps {
  sequence: CaseStudySequence | SimulationEhrSequence;
}

const CaseSimulationCommonOverviewView = (props: CaseStudyOverviewViewProps) => (
  <div>
    <h1 className="u-els-margin-top-3x">{props.sequence.content?.title}</h1>
    <p className="u-els-margin-top-2x u-els-margin-bottom">
      <MultiLine text={props.sequence.content?.overview} />
    </p>
  </div>
);

CaseSimulationCommonOverviewView.displayName = 'CaseSimulationCommonOverviewView';
export default CaseSimulationCommonOverviewView;
